import { Box, Typography } from "@mui/material";

import { UserTableContainer, styles } from "./styles";
import { useContext, useState } from "react";
import { EditProfileModal } from "../../components/Modal/EditProfileModal";
import { User } from "../../proto/api_pb";
import { columns } from "./types";
import { UserDetailsContext } from "../../contexts";
import { FONT_FAMILY } from "../../theme";

export const AdminControls: React.FC = () => {
  const { allUsers } = useContext(UserDetailsContext);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedUser, setSelectedUser] = useState<User>();

  const handleModal = (el: User) => {
    setIsModalOpen(!isModalOpen);
    setSelectedUser(el);
  };

  return (
    <>
      {selectedUser && (
        <EditProfileModal
          isModalOpen={isModalOpen}
          selectedUser={selectedUser}
          handleModal={handleModal}
        />
      )}

      <Box sx={{ textAlign: "center" }}>
        <Typography margin={5} variant="h4">
          Users
        </Typography>

        <div style={{ fontFamily: FONT_FAMILY }} className="container-earn">
          <div style={{ minWidth: "1450px" }}>
            <UserTableContainer>
              <div style={styles.userDetailsContainer}>
                {columns.map((el) => {
                  return <div key={el}>{el}</div>;
                })}
              </div>
              <hr style={{ color: "#A4A4A4" }} />
              {allUsers.map((el) => {
                if (el.getUsername() === "") {
                  return;
                }
                return (
                  <Box key={el.getUserId()}>
                    <div
                      onClick={() => handleModal(el)}
                      key={el.getUserId()}
                      style={styles.userDetailsContainer}
                    >
                      <div>{el.getUsername()}</div>
                      <div>{el.getFirstName()}</div>
                      <div>{el.getLastName()}</div>
                      <div>{el.getEmail()}</div>
                      <div>
                        {el.getApproved() ? "Approved" : "Not Approved"}
                      </div>
                    </div>
                    <hr />
                  </Box>
                );
              })}
            </UserTableContainer>
          </div>
        </div>
      </Box>
    </>
  );
};
